export default __webpack_public_path__ + "static/media/passive-auth-sk-light.df9e2d11.png";